import DataApi from "./DataApi";

class UserGroupApi extends DataApi {
  constructor() {
    super("usergroup");
  }

  /**
   * Fetch all user groups
   * @param {boolean} activeOnly - Only fetch active groups
   */
  async fetchAll(activeOnly = true) {
    return await this.get(`?activeOnly=${activeOnly}`);
  }

  /**
   * Fetch a single user group by ID
   * @param {string} id - Group UUID
   */
  async fetchById(id) {
    return await this.get(`/${id}`);
  }

  /**
   * Search user groups by name
   * @param {string} searchTerm - Search term for group name
   */
  async searchByName(searchTerm) {
    return await this.get(`/search/name?search=${encodeURIComponent(searchTerm)}`);
  }

  /**
   * Get user groups for a specific user
   * @param {string} userId - User UUID
   */
  async fetchByUserId(userId) {
    return await this.get(`/user/${userId}`);
  }

  /**
   * Create a new user group
   * @param {Object} groupData - Group data
   */
  async createGroup(groupData) {
    console.log("Creating user group:", groupData);
    return await this.post("", groupData);
  }

  /**
   * Update an existing user group
   * @param {string} id - Group UUID
   * @param {Object} updateData - Updated group data
   */
  async updateGroup(id, updateData) {
    console.log("Updating user group:", id, updateData);
    return await this.put(`/${id}`, updateData);
  }

  /**
   * Delete a user group
   * @param {string} id - Group UUID
   */
  async deleteGroup(id) {
    return await this.delete(id);
  }

  /**
   * Add users to a group
   * @param {string} groupId - Group UUID
   * @param {Array} userIds - Array of user UUIDs
   */
  async addUsers(groupId, userIds) {
    return await this.post(`/${groupId}/add-users`, { user_ids: userIds });
  }

  /**
   * Remove users from a group
   * @param {string} groupId - Group UUID
   * @param {Array} userIds - Array of user UUIDs
   */
  async removeUsers(groupId, userIds) {
    return await this.post(`/${groupId}/remove-users`, { user_ids: userIds });
  }
}

export default UserGroupApi;
